import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

// SERVICES

const styles = theme => ({
  //
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  topHalf: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    // border: '1px solid red',
  },
  bottomHalf: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    // border: '1px solid green',
  },

  image: {
    maxHeight: '80%',
    maxWidth: '100%',

    borderRadius: 5,
    padding: '20px 30px',
    background: '#00000022',
  },

  questionLabel: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  answerContainer: {
    fontSize: '1.25rem',
    width: '100%',
    textAlign: 'center',
  },

  actionContainer: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    //background: 'orange',
    paddingTop: 5,
    paddingBottom: 5,
  },
});

const YesNoCard = withStyles(styles)(
  ({
    // form values
    cardNumber,
    questionId,
    questionImage,
    questionLabel,
    questionLabel2,
    //
    // functions
    updateAnswer,
    confirmAnswer,
    //
    // other
    isActive,
    classes,
    goBack,
    hideBackButton,
  }) => {
    const handleYes = () => {
      updateAnswer({
        cardNumber,
        questionId,
        value: true,
      });

      confirmAnswer({
        cardNumber,
        questionId,
        answerValue: 3,
      });
    };

    const handleNo = () => {
      updateAnswer({
        cardNumber,
        questionId,
        value: false,
      });

      return confirmAnswer({
        cardNumber,
        questionId,
        answerValue: 4,
      });
    };

    return (
      <div className={classes.container}>
        <div className={classes.container}>
          <div className={classes.topHalf}>
            {!!questionImage && <img className={classes.image} src={questionImage} />}
          </div>

          <div className={classes.bottomHalf}>
            {!!questionLabel && <SelfInspectQuestionLabel isHeader>{questionLabel}</SelfInspectQuestionLabel>}

            {!!questionLabel2 && (
              <SelfInspectQuestionLabel
                isHeader
                style={{
                  marginTop: 20,
                }}
              >
                {questionLabel2}
              </SelfInspectQuestionLabel>
            )}
          </div>
        </div>
        <div className={classnames(classes.actionContainer)}>
          {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="flex-1 mr-20" />}

          <SelfInspectButton
            //
            label={'No'}
            secondary
            onClick={handleNo}
            className="flex-1 mr-20"
          />

          <SelfInspectButton
            //
            label={'Yes!'}
            onClick={handleYes}
            className="flex-1"
          />
        </div>
      </div>
    );
  },
);

YesNoCard.propTypes = {};

YesNoCard.defaultProps = {};

export default YesNoCard;
